<div class="grid-wrapper-reset">
    <div style="grid-row: 1; grid-column: 1;">
        <dx-select-box [dataSource]="approvalLevelStatusesToSelect"
                        [placeholder]="placeholderStatusSelect"
                            [(value)]="selectedStatusId"
                            displayExpr="Code"
                            valueExpr="StatusId"></dx-select-box>
    </div>
    <div style="grid-row: 2; grid-column: 1 / span 2">
        <app-elevation-section [title]="ls.LNG('Label.Available.Categories.And.Statuses.To.Reset')" [hasShowButton]="false" style="margin-bottom: 20px">
            <dx-data-grid #datagriddx rowAlternationEnabled="true"
                            [height]="300"
                            [dataSource]="approvalLevelRecords"
                            [columnAutoWidth]="true">
                <dxo-paging [pageSize]="20"></dxo-paging>
                <dxo-search-panel width="240"></dxo-search-panel>
                <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
                <dxi-column dataField="RoleId" [caption]="ls.LNG('Label.Role')" >
                <dxo-lookup [dataSource]="roles"
                            valueExpr="RoleId"
                            displayExpr="Name">
                </dxo-lookup>
                </dxi-column>
                <dxi-column dataField="CategoryId" [caption]="ls.LNG('Label.Category')" >
                <dxo-lookup [dataSource]="categories"
                            valueExpr="CategoryId"
                            displayExpr="Code">
                </dxo-lookup>
                </dxi-column>
                <dxi-column dataField="FromStatusId" [caption]="ls.LNG('Label.From.Status')">
                <dxo-lookup [dataSource]="statuses"
                            valueExpr="StatusId"
                            displayExpr="Code">
                </dxo-lookup>
                </dxi-column>
                <dxi-column dataField="ToStatusId" [caption]="ls.LNG('Label.To.Status')">
                <dxo-lookup [dataSource]="statuses"
                            valueExpr="StatusId"
                            displayExpr="Code">
                </dxo-lookup>
                </dxi-column>   
                <dxi-column caption=" " cellTemplate="cellTemplateStatus" [width]="55" [allowEditing]="false" calculateSortValue="ToStatusId" >
                </dxi-column>
                <div *dxTemplate="let c of 'cellTemplateStatus'">
                </div>
            </dx-data-grid>
        </app-elevation-section>
    </div>

    <div style="grid-row: 3;">
        <dx-button [text]="this.ls.LNG('Label.Button.OK')" (onClick)="onReset()" style="margin-right: 10px">

        </dx-button>
        <dx-button [text]="this.ls.LNG('Label.Button.Cancel')" (onClick)="onResetCancelled()">

        </dx-button>
    </div>
</div>